export default {
  cardMediaImg: 'mx-auto block',
};
